var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscordLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.6,7.3c-2.5-1.2-5.3-2.1-8.1-2.5c-0.3,0.6-0.8,1.5-1,2.2c-3-0.5-6-0.5-9,0c-0.3-0.7-0.7-1.5-1.1-2.2 c-2.8,0.5-5.6,1.4-8.1,2.6c-5.1,7.8-6.5,15.3-5.8,22.8c3.4,2.5,6.7,4.1,9.9,5.1c0.8-1.1,1.5-2.3,2.1-3.5c-1.2-0.4-2.3-1-3.4-1.6 c0.3-0.2,0.6-0.4,0.8-0.7c6.5,3,13.5,3,19.9,0c0.3,0.2,0.5,0.4,0.8,0.7c-1.1,0.6-2.2,1.2-3.4,1.6c0.6,1.2,1.3,2.4,2.1,3.5 c3.2-1,6.5-2.6,9.9-5.1C40.3,21.5,38.1,14,33.6,7.3z M13.5,25.5c-1.9,0-3.5-1.8-3.5-4s1.6-4,3.5-4c2,0,3.6,1.8,3.5,4 C17,23.7,15.4,25.5,13.5,25.5z M26.5,25.5c-1.9,0-3.5-1.8-3.5-4s1.6-4,3.5-4c2,0,3.6,1.8,3.5,4C30.1,23.7,28.5,25.5,26.5,25.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordLight);
export default __webpack_public_path__ + "static/media/discord-light.f96660e742f4fa2c5998d350694d4332.svg";
export { ForwardRef as ReactComponent };